export * from './datei-arts.page';
export * from './datei-arts.page.resolver';
